import Api from "./Api";
import apiPath from "@/constants/api.js";

export default {
  getTopMenu() {
    const response = Api().post(apiPath.menu + "top");
    return response;
  },

  getSubmenu(slug, page) {
    const response = Api().post(apiPath.menu + slug, page);
    return response;
  }
};
